import { urls } from 'Reducers/projects';
import { createSelector } from 'reselect';
import { camelize, decodeSearch } from 'Helpers/strings';
import { paramsToQueryString } from 'Helpers/url';
import { getCollectionMetadataKey } from 'Reducers/componentHelpers';
import { urlJoin } from 'Helpers/url';
import { slugify } from 'Helpers/strings';
import { selectedLocationSelector } from './location';
import { getSelectedLangCode } from 'Selectors/config';
import { getType } from 'Reducers/helpers/typeModifier';

export const getLangParams = state => {
    const langParams = {
        lang: getSelectedLangCode(state)
    };

    return langParams.lang ? langParams : null;
};

export const getProjectId = props => {
    const projectSlugParams = props.params && props.params.projectSlug && props.params.projectSlug.split('-');

    if (projectSlugParams) {
        return projectSlugParams[0];
    }

    return null;
};

export const getProject = createSelector(
    state => state.projects && state.projects.elements,
    (_, props) => getProjectId(props),
    (elements, projectId) => {
        if (!projectId) {
            return null;
        }

        return elements[projectId];
    }
);

export const fetchingProject = createSelector(
    state => state.projects && state.projects.isFetching,
    (_, props) => getProjectId(props),
    getLangParams,
    (isFetchingObj, projectId, langParams) => {
        let url = urls.getProject(projectId);

        url = langParams ? `${url}?${paramsToQueryString(langParams)}` : url;
        return isFetchingObj[getType('PROJECTS', url)];
    }
);

export const isError = createSelector(
    state => state.projects && state.projects.isError,
    (_, props) => getProjectId(props),
    (isErrorObj, projectId) => {
        const url = urls.getProject(projectId);

        return isErrorObj[getType('PROJECTS', url)];
    }
);

export const getListingParams = createSelector(
    (state, props) => selectedLocationSelector(state, props),
    (_, props) => props.countryLocation,
    (_, props) => props.params.geoID || props.locationId,
    (_, props) => props.params.constructionStatus || props.constructionStatus,
    (selectedLocation, countryLocation, geoId, filteredStatus) => {
        const currLoc = selectedLocation && selectedLocation.id ? selectedLocation : countryLocation;
        const locationId = geoId || currLoc.id;

        return {
            filter: {
                locationId,
                constructionStatus: filteredStatus ? camelize(decodeSearch(filteredStatus)) : ''
            },
            getFilters: 1
        };
    }
);

export const fetchingProjects = createSelector(
    state => state.projects && state.projects.isFetching,
    (state, props) => getListingParams(state, props),
    getLangParams,
    (isFetchingObj, params, langParams) => {
        let url = urls.getAllProjects;

        url = langParams ? `${url}?${paramsToQueryString({ ...params, ...langParams })}` : `${url}?${paramsToQueryString(params)}`;
        return isFetchingObj[getType('GET_ALL_PROJECTS', url)];
    }
);

export const projectFacetFilterSelector = createSelector(
    (state, props) => state && state.projects && getCollectionMetadataKey('locationFilter', 'GET_ALL_PROJECTS', state.projects, urls.getAllProjects, { ...getListingParams(state, props), ...getLangParams(state) }),
    projects => projects
);

export const buildProjectURL = ({ location, constructionStatus, base } = {}) => {
    const url = [];

    if (base === 'projects') {
        url.push(base);
    }
    if (location && location.id && location.name) {
        url.push(`${ slugify(location.name) }_g${ location.id }`);
    }
    if (constructionStatus) {
        url.push(constructionStatus);
    }

    return `/${urlJoin(...url)}`;
};

const getLeadFormParams = ownProps => {
    const params = {
        from: ownProps.fromPage,
        ...ownProps.leadFormGetParams
    };

    return params;
};

export const fetchingLeadForm = createSelector(
    state => state.projects && state.projects.isFetching,
    (_, props) => getLeadFormParams(props),
    getLangParams,
    (isFetchingObj, params, langParams) => {
        const url = `${urls.getLeadFormData}?${paramsToQueryString(params)}`;

        return langParams ? isFetchingObj[getType('PROJECT_LEAD_FORM', `${url}&${paramsToQueryString(langParams)}`)] : isFetchingObj[getType('PROJECT_LEAD_FORM', url)];
    }
);
